import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      id: 1,
      title: "Muhasebe Yönetimi",
      description: "Kasa durumunuzu anlık olarak takip edin. Nakit, kart ve havale ödemelerini ayrı ayrı görüntüleyin. Günlük, haftalık ve aylık gelir raporlarınızı detaylı şekilde inceleyin.",
      image: "/assets/telefon2-min.png",
      highlight: "Anlık Kasa Takibi"
    },
    {
      id: 2,
      title: "Randevu Planlama",
      description: "Haftalık randevu takviminizi kolayca yönetin. Müşteri bilgilerini görüntüleyin, randevu saatlerini düzenleyin ve çakışmaları önleyin. Personel bazında randevu dağılımını optimize edin.",
      image: "/assets/telefon4-min.png",
      highlight: "Haftalık Takvim Görünümü"
    },
    {
      id: 3,
      title: "Personel Yönetimi",
      description: "Personel performansını takip edin, çalışma saatlerini düzenleyin ve yetki seviyelerini belirleyin. Her personelin randevu sayısını ve gelir katkısını analiz edin.",
      image: "/assets/telefon3-min.png",
      highlight: "Performans Analizi"
    },
    {
      id: 4,
      title: "Web Sitesi Entegrasyonu",
      description: "Otomatik oluşturulan web siteniz üzerinden online randevu alın. Müşterileriniz 7/24 randevu oluşturabilir, mevcut randevularını görüntüleyebilir ve iptal edebilir.",
      image: "/assets/bilgisayar1.png",
      highlight: "Online Randevu Sistemi"
    }
  ];

  return (
    <section id="features" className="features section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            Salon İşletmenizi <span className="gradient-text">Dijitalleştirin</span>
          </h2>
          <p className="section-description">
            Modern salon yönetimi için tasarlanmış özelliklerle işletmenizi bir adım öne taşıyın
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={feature.id} className={`feature-item ${index % 2 === 0 ? 'reverse' : ''}`}>
              <div className="feature-content">
                <div className="feature-badge">{feature.highlight}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <div className="feature-cta">
                  <span className="cta-text">Detayları İncele</span>
                  <span className="cta-arrow">→</span>
                </div>
              </div>
              <div className="feature-image">
                          <div className="image-container">
            <img src={feature.image} alt={feature.title} className="feature-img" />
          </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features; 